
import HttpService from './HttpService'
import ConstDef from '../ConstDef'
import ParamModel from '../domain/ParamModel'
import AesCrypto from './AesCrypto'
import UserGroupModel from '../domain/UserGroupModel'

export default class FindAllTopMenuProc {
  static SendParamModel () {
    let jsonObject = {
      'proc': 'spFindAllTopMenu',
      'ps': {
      }
    }
    let plainText = JSON.stringify(jsonObject)
    let encode = AesCrypto.GetEncryptString(plainText)
    let param = new ParamModel()
    param.command = ConstDef.CONNECT
    param.body = encode
    return HttpService.select(param)
  }

  static MakeModel (data, store) {
    let json = JSON.parse(data.body)
    let topMenu = []
    let menuItem = null
    let userGroupArray = ConstDef.USER_PERMISSION
    for (let i = 0; i < json.length; i++) {
      if (json[i].parentMenuId === '0') {
        if (menuItem !== null) {
          topMenu.push(menuItem)
        }
        menuItem = {}
        menuItem.parentMenuId = json[i].parentMenuId
        menuItem.menuId = json[i].menuId
        menuItem.caption = json[i].menuName
        // console.log(json[i].menuName)
        menuItem.url = json[i].url
        menuItem.permission = json[i].permission
        menuItem.subMenu = []
        menuItem.userGroup = []
        for (let j = 0; j < userGroupArray.length; j++) {
          let group = new UserGroupModel()
          group.groupName = userGroupArray[j].groupName
          group.checked = (((json[i].permission >> j) & 0x01) === 0x01)
          group.permission = userGroupArray[j].permission
          menuItem.userGroup.push(group)
        }
      } else {
        let subMenu = {}
        subMenu.parentMenuId = json[i].parentMenuId
        subMenu.menuId = json[i].menuId
        subMenu.caption = json[i].menuName
        subMenu.url = json[i].url
        subMenu.permission = json[i].permission
        subMenu.userGroup = []
        for (let j = 0; j < userGroupArray.length; j++) {
          let group = new UserGroupModel()
          group.groupName = userGroupArray[j].groupName
          group.checked = (((json[i].permission >> j) & 0x01) === 0x01)
          group.permission = userGroupArray[j].permission
          subMenu.userGroup.push(group)
        }
        menuItem.subMenu.push(subMenu)
      }
    }
    topMenu.push(menuItem)

    // console.log(topMenu)
    return topMenu
  }
}
